export default __webpack_public_path__ + "static/media/welcome-tour-3-mob.541b8178.png";